import { api } from '../lib/api';

export interface UserProfile {
  id: string;
  email: string;
  name: string;
  profileImageUrl: string | null;
  bio: string | null;
  phone: string | null;
  contactEmail: string | null;
  createdAt: string;
}

export interface UpdateProfileInput {
  name?: string;
  bio?: string;
  phone?: string;
  contactEmail?: string;
  profileImage?: File;
}

/**
 * Get all users (members list)
 */
export const getAllUsers = async (): Promise<UserProfile[]> => {
  const response = await api.get<UserProfile[]>('/users');
  return response.data;
};

/**
 * Get user profile by ID
 */
export const getUserById = async (userId: string): Promise<UserProfile> => {
  const response = await api.get<UserProfile>(`/users/${userId}`);
  return response.data;
};

/**
 * Update own profile
 */
export const updateProfile = async (input: UpdateProfileInput): Promise<UserProfile> => {
  // If profile image is provided, use multipart form data
  if (input.profileImage) {
    const formData = new FormData();
    if (input.name) formData.append('name', input.name);
    if (input.bio) formData.append('bio', input.bio);
    if (input.phone !== undefined) formData.append('phone', input.phone);
    if (input.contactEmail !== undefined) formData.append('contactEmail', input.contactEmail);
    formData.append('profileImage', input.profileImage);

    const response = await api.patch<UserProfile>('/users/me', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  // Otherwise use JSON
  const response = await api.patch<UserProfile>('/users/me', {
    name: input.name,
    bio: input.bio,
    phone: input.phone,
    contactEmail: input.contactEmail,
  });
  return response.data;
};

export const getCalendarToken = async (): Promise<{ calendarToken: string }> => {
  const response = await api.get<{ calendarToken: string }>('/users/me/calendar-token');
  return response.data;
};

export const regenerateCalendarToken = async (): Promise<{ calendarToken: string }> => {
  const response = await api.post<{ calendarToken: string }>('/users/me/calendar-token/regenerate');
  return response.data;
};
